export const SidebarData=[
    {
        icon:"UilEstate",
        heading:"Dashboard",
    },
    {
        icon:"UilEstate",
        heading:"Orders",
    },
    {
        icon:"UilEstate",
        heading:"Customers",
    },
    {
        icon:"UilEstate",
        heading:"Products",
    },
    {
        icon:"UilEstate",
        heading:"Analytics",
    },
    {
        icon:"UilEstate",
        heading:"Dashboard",
    }
]